/* global angular, Bloodhound, _, $ */
angular.module('ua5App.index.search')
    .config(['$stateProvider', function($stateProvider) {
        $stateProvider.state('index.search', {
            url: 'search',
            templateUrl: 'states/index.search/index.search.html',
            controller: 'SearchCtrl',
            controllerAs: 'ctrl',
            params: {
                query: null
            }
        });
    }])
    .run(['$rootScope', '$state', function($rootScope, $state) {
        var body = angular.element('body');
        body.bind('keydown', function(e) {
            var keyCode = e.keyCode;
            var letter;
            // If keyCode is a letter key
            if (
                (!$rootScope.inSearch) && (!e.metaKey) &&
                ((keyCode > 64 && keyCode < 91) && keyCode !== 16)
            ) {
                // Don't send letter if user hits the shift
                letter = keyCode !== 16 ? String.fromCharCode(keyCode) : null;
                $state.go('index.search', {query: letter});
            }
        });
        // Check to see if in search when route changes
        $rootScope.$on('$stateChangeSuccess', function(e, toState) {
            $rootScope.inSearch = toState.url === 'search';
        });
    }])
    .controller('SearchCtrl', [
    'posts',
    '$filter',
    '$stateParams',
    '$scope',
    '$state',
    'MetaFactory',
    function(posts, $filter, $stateParams, $scope, $state, MetaFactory) {
        var allArtists = [];
        var allTags = [];
        var allWriters = [];
        var dataSet = [];
        var tagList = [];
        var self = this;
        this.terms = [];
        angular.forEach(posts, function(post) {
            var slug = post.slug;
            // Get all artists from posts
            allArtists.push({
                type: 'artist',
                name: post.title.replace(/&#038;/g, '&'),
                state: 'index.artist',
                params: {
                    artist: slug
                }
            });
            angular.forEach(post.acf.artwork, function(artwork, i) {
                var index = i + 1;
                // Get all tags from posts
                tagList = tagList.concat(artwork.tag.replace(/, /g, ',').split(','));
                // Get all writers from posts
                allWriters.push({
                    type: 'writer',
                    name: artwork.commissioned_text_writer, // jshint ignore:line
                    state: 'index.artist',
                    params: {
                        artist: slug,
                        index: index,
                        show_response: 'true' // jshint ignore:line
                    }
                });
            });
        });
        // Remove duplicates
        tagList = _.uniq(tagList);
        // Turn array of strings into array of objects so that Bloodhound can
        // use as dataset.
        angular.forEach(tagList, function(tag) {
            // Add tags to dataSet
            allTags.push({
                type: 'tag',
                name: tag,
                state: 'index.tag',
                params: {
                    tag: tag
                }
            });
        });
        // Add artists and writers to dataSet
        $scope.dataSet = dataSet.concat(allTags).concat(allArtists).concat(allWriters);

        self.initialValue = $stateParams.query;

        $scope.$on('gotSuggestions', function(e, suggestions) {
            self.terms = [];
            self.terms = suggestions;
            $scope.$apply();
        });

        // Set meta information
        MetaFactory.set({
            title: 'Search | Storylines: Contemporary Art at the Guggenheim',
            ogTitle: 'Search | Storylines: Contemporary Art at the Guggenheim'
        });
    }])
    .directive('submitChoiceOnEnter', ['$analytics', function($analytics) {
        return {
            restrict: 'A',
            link: function($scope, $element, $attrs) {
                $($element).on('keyup', function(e) {
                    // On enter
                    if (e.which === 13) {
                        // Click on the first selection
                        $('.tt-suggestion:first-child').click();
                        $analytics.eventTrack('Click', {
                            category: 'Microsite Storylines | Discovery',
                            label: 'Enter Search Box'
                        });
                    }
                });
            }
        };
    }])
    .directive('typeahead', ['$timeout', '$state', function($timeout, $state) {
        return {
            restrict: 'A',
            link: function($scope, $element, $attrs) {
                $timeout(function() {
                    var data = new Bloodhound({
                        datumTokenizer: Bloodhound.tokenizers.obj.whitespace('name'),
                        queryTokenizer: Bloodhound.tokenizers.whitespace,
                        local: $scope.dataSet
                    });
                    $($element).typeahead({
                        hint: true,
                        highlight: true,
                        minLength: 1
                    }, {
                        name: 'test',
                        source: data,
                        display: 'name'
                    });
                });
                $($element).bind('typeahead:render', function() {
                    var suggestions = Array.prototype.slice.call(arguments);
                    suggestions.shift();
                    $scope.$emit('gotSuggestions', suggestions);
                });

                $($element).bind('typeahead:select', function(e, suggestion) {
                    $state.go(suggestion.state, suggestion.params);
                });
            }
        };
    }])
;
